import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SecurityRoleOrganization } from '../../../shared/interfaces/entities/security-role-organization.interface';
import { ReadOnlyProperty } from '../../../shared/ui/control-options/control-option.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { INotificationService } from '../../../shared/services/inotification.service';
import { OrganizationSelect } from '../../../shared/ui/select-controls/organizations-select.model';
import { faSave } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-security-role-organization',
    templateUrl: './security-role-organization.component.html',
    styleUrls: ['./security-role-organization.component.css'],
    standalone: false
})
export class SecurityRoleOrganizationComponent implements OnInit {

  @Input() entity: SecurityRoleOrganization;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  organizationSelect: OrganizationSelect;

  saveIcon = faSave;
  saving: boolean = false;

  constructor(private fb: FormBuilder) { }

  public form: FormGroup;

  ngOnInit(): void {
    var isNew: boolean = this.entity == undefined || this.entity == null || this.entity.id == undefined || this.entity.id == 0;

    var organizationValue = { id: this.entity.organizationId, name: this.entity.organization_Name }
    this.organizationSelect = new OrganizationSelect("organiationId", "Organization", organizationValue);

    if (!isNew) {
      this.organizationSelect.addOption(new ReadOnlyProperty());
      // Get the other options that can be selected

      var obj = {
        value: { id: this.entity.organizationId }
      };
    } else {
      this.entity.id = 0;
      var securityRoleId = Number(window.location.pathname.split('/').at(-1));
      this.entity.securityRoleId = securityRoleId;
    }

    this.form = this.fb.group({
      id: [this.entity.id],
      organization_Name: [this.entity.organization_Name],
      organizationId: [this.entity.organizationId],
      securityRoleId: [this.entity.securityRoleId],
      clientAdminCanEdit: [this.entity.clientAdminCanEdit == null ? false : this.entity.clientAdminCanEdit]
    });
  }

  save() {
    var organizationId = this.organizationSelect.getValue();

    if (organizationId == undefined || organizationId == null || organizationId.length == 0) {
      var l = document.getElementById(this.organizationSelect.id);
      if (l) {
        l.style.border = "2px solid orangered";
      }
      return;
    } else {
      this.saving = true;

      this.form.controls['organizationId'].setValue(organizationId);

      this.submitForm.emit(this.form);
    }
  }
}
